var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnProject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66667 6.75H19.3333V15.5H4.66667V6.75ZM19.3333 17.25C19.8196 17.25 20.2859 17.0656 20.6297 16.7374C20.9735 16.4092 21.1667 15.9641 21.1667 15.5V6.75C21.1667 5.77875 20.3417 5 19.3333 5H4.66667C3.64917 5 2.83333 5.77875 2.83333 6.75V15.5C2.83333 15.9641 3.02649 16.4092 3.3703 16.7374C3.71412 17.0656 4.18044 17.25 4.66667 17.25H1V19H23V17.25H19.3333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnProject);
export default __webpack_public_path__ + "static/media/onProject.119d2df2.svg";
export { ForwardRef as ReactComponent };